import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import { Translation } from 'cng-common/features/translations'

import { MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS } from '../../../configs/translations'
import {
  requestMarketYoyGrowthExpectationsData,
  selectIsMarketYoyGrowthExpectationsEditable,
  selectIsMarketYoyGrowthExpectationsFetching,
  selectIsMarketYoyGrowthSaving,
  selectMarketYoyGrowthExpectationGeoMarkets,
  selectMarketYoyGrowthExpectationsWorkflowState,
  selectMarketYoyGrowthExpectationUserInfo,
  selectMarketYoyGrowthSelectedFYear,
} from '../../../model'
import { MarketYoyGrowthExpectationHeader } from '../../marketYoyGrowthExpectationHeader'
import { MarketYoyGrowthExpectationLogTable } from '../../marketYoyGrowthExpectationLogTable'
import { MarketYoyGrowthExpectationTable } from '../../marketYoyGrowthExpectationTable'

import styles from './MarketYoyGrowthExpectation.module.scss'

export const MarketYoyGrowthExpectation = () => {
  const dispatch = useAppDispatch()
  const selectedFYear = useSelector(selectMarketYoyGrowthSelectedFYear)
  const isLoading = useSelector(selectIsMarketYoyGrowthExpectationsFetching)
  const isSaving = useSelector(selectIsMarketYoyGrowthSaving)
  const workflowState = useSelector(selectMarketYoyGrowthExpectationsWorkflowState)
  const isEditable = useSelector(selectIsMarketYoyGrowthExpectationsEditable)
  const userInfo = useSelector(selectMarketYoyGrowthExpectationUserInfo)
  const geoMarkets = useSelector(selectMarketYoyGrowthExpectationGeoMarkets)

  // The year defaults to JBPSettings.CurrentFYear, so the settings must load and nothing is
  // requested before they do.
  useJbpSettings(false)

  useEffect(() => {
    if (selectedFYear) {
      dispatch(requestMarketYoyGrowthExpectationsData({ fYear: selectedFYear }))
    }
  }, [dispatch, selectedFYear])

  const isRecognizedRole =
    userInfo.viewType === 'WorldWide' ||
    userInfo.viewType === 'Market' ||
    userInfo.viewType === 'Admin'

  if (!isRecognizedRole) {
    return (
      <div className={styles.root}>
        <InfoBlock
          type={InfoBlockType.Danger}
          text={<Translation text={MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS.notAllowed} />}
        />
      </div>
    )
  }

  const marketName =
    geoMarkets.find((geoMarket) => geoMarket.short === userInfo.market)?.name ?? userInfo.market

  return (
    <div className={styles.root}>
      <MarketYoyGrowthExpectationHeader
        workflowState={workflowState}
        viewType={userInfo.viewType}
        marketName={marketName}
      />

      <LoaderOverlay isVisible={isLoading || isSaving} />

      <MarketYoyGrowthExpectationTable isEditable={isEditable} />

      <MarketYoyGrowthExpectationLogTable />
    </div>
  )
}

MarketYoyGrowthExpectation.displayName = 'MarketYoyGrowthExpectation'

export default MarketYoyGrowthExpectation
